import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MessageBusService {

    private genericConfirm = new Subject();

    setMessage(message: any) {
        this.genericConfirm.next(message);
    }

    getMessage(): Observable<any> {
        return this.genericConfirm.asObservable();
    }

}
